var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWnLogoTextWhiteGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 461.57 45.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ffc629;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267.41,307.22h-7.33l-4.42-25.87L251,307.22h-7.25l-7.79-44h8.12l4,29,4.88-29h6.33l4.49,29,4.22-29h7.59Z",
    transform: "translate(-235.93 -262.35)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M306.33,307.22l-1.45-8.65H297.1l-1.59,8.65h-7.65l8.84-44h9.17l8.78,44Zm-5.14-32.07-3,17h5.61Z",
    transform: "translate(-235.93 -262.35)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M348,307.22,342,289.14l-2.84,5.8v12.28H331v-44h8.18V283.4L348,263.27h8.25l-8.64,18.54,9,25.41Z",
    transform: "translate(-235.93 -262.35)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M373.11,307.22v-44h21v7.06H381.3v10.89h8.84v6.47H381.3v12.2h12.8v7.33Z",
    transform: "translate(-235.93 -262.35)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M430.79,307.22l-8.52-18.74-3.1-7v25.74h-7.52v-44h7.06l8.11,19.07,2.91,7V263.27h7.39v44Z",
    transform: "translate(-235.93 -262.35)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M456,307.22v-44h21v7.06h-12.8v10.89H473v6.47h-8.85v12.2H477v7.33Z",
    transform: "translate(-235.93 -262.35)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M508.78,270.53v36.69h-8.25V270.53h-8.12v-7.26h24.42v7.26Z",
    transform: "translate(-235.93 -262.35)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M562.56,307.22h-7.33l-4.42-25.87-4.68,25.87h-7.26l-7.79-44h8.12l4,29,4.88-29h6.34l4.48,29,4.23-29h7.59Z",
    transform: "translate(-235.93 -262.35)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M598.79,308.21c-7.66,0-12.48-5-12.48-12V274.29c0-6.93,4.82-11.94,12.48-11.94s12.47,5,12.47,11.94V296.2C611.26,303.19,606.51,308.21,598.79,308.21ZM603,273.76a3.94,3.94,0,0,0-4.22-4.29c-2.64,0-4.16,1.72-4.16,4.29v23c0,2.57,1.52,4.29,4.16,4.29a3.94,3.94,0,0,0,4.22-4.29Z",
    transform: "translate(-235.93 -262.35)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M650,307.48c-3.23,0-4.49-2.64-4.49-6.46v-8.25c0-2-1-3.76-3.36-3.76h-4.29v18.21h-8.18v-44H643.2c6,0,10,3.43,10,9.57V279a6.53,6.53,0,0,1-5,6.8,6.74,6.74,0,0,1,5.08,6.66v8.05a6.15,6.15,0,0,0,1.58,4.49v2.44Zm-4.75-34.31c0-2-.86-3.17-2.9-3.17h-4.49v12.94H642c2.11,0,3.23-1.13,3.23-3.5Z",
    transform: "translate(-235.93 -262.35)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M688.92,307.22l-6.07-18.08-2.83,5.8v12.28h-8.19v-44H680V283.4l8.84-20.13h8.25l-8.65,18.54,9,25.41Z",
    transform: "translate(-235.93 -262.35)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWnLogoTextWhiteGold);
export default __webpack_public_path__ + "static/media/wn-logo-text-white-gold.d625980d0e5824423864bde9c6015f88.svg";
export { ForwardRef as ReactComponent };